<template>
  <div class="ruta"> <!-- navMarginSmall -->
    <NavBar :transparent-on-top="true"></NavBar>
    <div class="bgimg-hidden" id="hidden" :style="'background-image: url(' + decoration.backgroundImage + ');'"></div>
    <div class="bgimg" :style="'background-image: linear-gradient(' + decoration.directionGradient + ', rgba(0,0,0,0), rgba(20,20,20,0.9), rgba(20,20,20,0.95), rgba(20,20,20,1)), url(' + decoration.backgroundImage + ');'"> <!-- article -->
      <div class="top">
        <vs-row style="display: flex; align-items: stretch" justify="space-evenly" align="end">
          <vs-col class="poster-side centrar" vs-type="flex" vs-justify="center" vs-align="center" w="3" xs="12" style="display: flex; justify-content: center">
            <img class="centrar detail-poster" :src="poster" width="90%" alt="Poster" @error="imageUrlAlt($event, true)" @mouseover="showFondo" @mouseleave="unshowFondo" @mouseout="unshowFondo">
          </vs-col>
          <vs-col style="display: flex;" class="content-side youNeedCoolAir" vs-type="flex" justify="center" align="center" w="8" xs="12">
            <vs-row class="hero-header" style="display: flex; align-content: end; text-align: left;">

              <!-- Action buttons -->
              <!-- <vs-col class="show-action-buttons">
                <vs-tooltip bottom>
                  <vs-button icon color="danger" border :active="mini.recommended" @click="markRecommended"><i class='bx bxs-heart'></i></vs-button>
                  <template #tooltip>Me gusta</template>
                </vs-tooltip>
                <vs-tooltip bottom>
                  <vs-button icon color="warn" border :active="mini.bookmark" @click="bookmark"><i class='bx bxs-bookmark' ></i></vs-button>
                  <template #tooltip>Añadir a Mi Lista</template>
                </vs-tooltip>
              </vs-col> -->

              <!-- Title -->
              <vs-col style="margin-top: 2rem">
                <div class="h1 show-title">{{ title }} <span class="badge tip middle hideWhenSmall" v-if="typeSerie !== ''">{{ typeSerie }}</span></div>
              </vs-col>


              <!-- Info --> <!-- TODO: Add better organization on categories/tags -->
              <vs-col>
                <!-- Mini info -->
                <small class="show-info">
                  <span class="show-qty">{{ getShowQty() }}</span>
                  <span class="show-year" v-if="year"> • {{ year }}</span>
                  <span class="show-status"> • {{ status }}</span>
                </small>

                <!-- More info --> <!-- TODO: To be deleted and added to "Info" tab -->
                <p style="margin-bottom: 0; padding:0; line-height: 1em;">
                  <span style="display: block;"><small v-if="atribucion" style="margin-top: 0;"><b>Atribución:</b> {{ atribucion }}</small></span>
                  <span style="display: block;"><small v-if="categorias.length > 0" style="margin-top: 0;">
                    <b>Categorías: </b>
                    <span v-for="(cat, index) in categorias" :key="cat.id"> <a :href="'https://videnti.co/watch/genre/' + cat.idCategoria">{{cat.nombre}}</a><span v-if="index !== categorias.length-1">, </span></span>
                  </small></span>
                </p>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div> <!-- top -->
    </div>
    <div>
      <vs-row style="display: flex; align-items: stretch" justify="space-evenly" align="end">
        <vs-col class="left-bottom-container" vs-type="flex" vs-justify="center" vs-align="center" w="3" xs="12">
          <div style="display: flex">
            <vs-button-group style="margin: 5px; width:100%">
              <vs-button :active="mini.recommended" flat size="large" danger>
                <i class='bx bxs-heart'></i> ‎
              </vs-button>
              <vs-button :active="mini.bookmark" flat block size="large" warn>
                <i class='bx bxs-bookmark button-margin-dialog'></i> Guardar
              </vs-button>
            </vs-button-group>
          </div>
          <div style="display: flex">
            <vs-button block size="large" v-if="continueWatching.finished || (continueWatching.nextSeasonIndex === 0 && continueWatching.nextEpisodeIndex === 0)">
              <i class='bx bxs-right-arrow button-margin-dialog'></i> {{ $t('episode.start_watching') }}
            </vs-button>
            <vs-button block size="large" v-else-if="continueWatching.timestamp !== -1">
              <i class='bx bxs-right-arrow button-margin-dialog'></i> {{ $t('episode.continue_watching', { epsiode: $t('general.season_no_episode_no_short', {season: temporadas[continueWatching.nextSeasonIndex].number, episode: temporadas[continueWatching.nextSeasonIndex].episodes[continueWatching.nextEpisodeIndex].episode_number}) }) }}
            </vs-button>
            <vs-button block size="large" v-else>
              <i class='bx bxs-right-arrow button-margin-dialog'></i> {{ $t('episode.next_up', { episode: $t('general.season_no_episode_no_short', {season: temporadas[continueWatching.nextSeasonIndex].number, episode: temporadas[continueWatching.nextSeasonIndex].episodes[continueWatching.nextEpisodeIndex].episode_number}) }) }}
            </vs-button>
          </div>

        </vs-col>
        <vs-col class="right-bottom-container" style="display: flex;" vs-type="flex" justify="center" align="center" w="8" xs="12">
          <vs-row style="display: flex; align-content: flex-start; text-align: left;">
            <vs-col w="11" style="margin: 1rem 0; display: flex; justify-content: center">
              <vs-button transparent size="l" :active="settings.currentTab === 'overview'" @click="settings.currentTab = 'overview'" >Resumen</vs-button>
              <vs-button transparent size="l" :active="settings.currentTab === 'episodes'" @click="settings.currentTab = 'episodes'" >Episodios</vs-button>
              <vs-button transparent size="l" :active="settings.currentTab === 'details'" @click="settings.currentTab = 'details'" >Detalle</vs-button>
              <vs-button transparent size="l" :active="settings.currentTab === 'reviews'" @click="settings.currentTab = 'reviews'" >Reseñas</vs-button>
            </vs-col>
            <div v-if="settings.currentTab === 'overview'" class="vs-row tab tab-overview">
              <vs-col class="info-block">
                <h3 class="overview-title">Información</h3>
                <small class="show-description">{{ description }}</small>
              </vs-col>
              <vs-col class="info-block">
                <h3 class="overview-title">Episodios</h3>
                <div class="episodes" v-if="!isFetching">
                  <div>
                    <div style="display: flex; justify-content: space-between">
                      <vs-select placeholder="" v-model="settings.currentSeason" class="season-selector">
                        <vs-option
                            v-for="(season, index) in temporadas"
                            :label="$t('general.season_no', { season: season.number }) + ( season.nombre ? ': ' + season.nombre : '' ) /* 'Temporada ' + season.number */"
                            :value="index"
                            :key="season.id">
                          {{ $t('general.season_no', { season: season.number }) }}{{ season.nombre ? ": " + season.nombre : "" }}
                        </vs-option>
                      </vs-select>
                      <div style="display: flex">
                        <vs-button icon circle primary @click="reversee(settings.currentSeason)">
                          <i class="bx bx-sort-up" v-if="temporadas[settings.currentSeason].isReversed"></i>
                          <i class="bx bx-sort-down" v-else></i>
                        </vs-button>
                        <vs-button icon circle primary @click="settings.currentTab = 'episodes'"> <!-- @click="changeEpisodeViewType('all', 0)"> -->
                          <i class="bx bx-grid-vertical"></i>
                        </vs-button>
                      </div>
                    </div>
                    <!-- Aquí deberían ir los episodios -->
                    <EpisodesGrid :columns="3" :episodes="temporadas[settings.currentSeason].episodes" :season-number="temporadas[settings.currentSeason].number" :series-url="$route.params.name"></EpisodesGrid>
                  </div>
                </div>
              </vs-col>
            </div>
            <div v-else-if="settings.currentTab === 'episodes'" class="vs-row tab tab-episodes">
              <div style="display: flex; justify-content: space-between">
                <vs-select placeholder="" v-model="settings.currentSeason" class="season-selector">
                  <vs-option
                      v-for="(season, index) in temporadas"
                      :label="$t('general.season_no', { season: season.number }) + ( season.nombre ? ': ' + season.nombre : '' ) /* 'Temporada ' + season.number */"
                      :value="index"
                      :key="season.id">
                    {{ $t('general.season_no', { season: season.number }) }}{{ season.nombre ? ": " + season.nombre : "" }}
                  </vs-option>
                </vs-select>
                <div style="display: flex">
                  <vs-button icon circle primary @click="reversee(settings.currentSeason)">
                    <i class="bx bx-sort-up" v-if="temporadas[settings.currentSeason].isReversed"></i>
                    <i class="bx bx-sort-down" v-else></i>
                  </vs-button>
                </div>
              </div>
              <EpisodesCardsVertical style="width: 100%; margin: 0 1rem;" :episodes="temporadas[settings.currentSeason].episodes" :season-number="temporadas[settings.currentSeason].number" :series-url="$route.params.name"></EpisodesCardsVertical>
            </div>
          </vs-row>
        </vs-col>
      </vs-row>

    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/auth'; // Asegúrate de que la ruta sea correcta

import axios from "axios";
import Footer from "../views/Footer";
import NavBar from "../components/NavBar";
import EpisodesGrid from "../components/EpisodesGrid.vue";
import EpisodesCardsVertical from "../components/EpisodesCardsVertical.vue";
import {getImageSource, getTVStatus} from "@/utils/helpers";

export default {
  name: "AnimeDetail",
  components: {EpisodesGrid, NavBar, Footer, EpisodesCardsVertical},

  setup() {
    const authStore = useAuthStore();
    const { isLoggedIn, token } = storeToRefs(authStore);

    return {
      authStore,
      isLoggedIn,
      token
    };
  },

  data () {
    return {
      isFetching: true,
      title: this.$route.params.title ? this.$route.params.title : 'Sin título',
      description: 'Sin descripción',
      status: null,
      poster: this.$route.params.poster_vertical ? this.$route.params.poster_vertical : 'https://storage.googleapis.com/balde-1/various/placeholders/noimg_y.png',
      // poster: 'https://storage.googleapis.com/balde-1/various/placeholders/noimg_y.png',
      images: {},
      idSerie: null,
      temporadas: [],
      publishers: [],
      typeSerie: '',
      atribucion: null,
      categorias: [],
      year: "",
      continueWatching: {
        nextSeasonIndex: 0,
        nextEpisodeIndex: 0,
        finished: false,
        timestamp: -1,
      },
      mini: {
        recommended: false,
        bookmark: false
      },
      decoration: {
        backgroundImage: "",
        directionGradient: "to right",
      },
      settings: {
        currentTab: "overview", // episodes
        // episodesViewType: "all",
        episodesViewType: "perSeason",
        currentSeason: 0
      }
    }
  },

  async created() {
    const loading = this.$vs.loading({ background: '#000', color: '#fff', text: 'Cargando...' });

    // Request show info
    await axios(
        `https://api.videnti.co/tv/getInfo/${this.$route.params.name}`,
        {
          method: (this.isLoggedIn ? "post" : "get"),
          headers: this.isLoggedIn ? { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': `Bearer ${this.$store.state.auth.token}` } : {},
          data: new URLSearchParams()
        }
    ).then(response => {
      if (response.data.error) {
        this.checkIfJWTExpired(response.data.message);
      } else if (!response.data[0]) {
        window.location = '../?error=SERIE_NO_EXISTE';
      }
      this.title = response.data[0].nombre;
      this.description = response.data[0].descripcion;
      // this.bgimg = response.data[0].poster_horizontal === '' ? 'https://i.imgur.com/Zx6wTMp.png' : response.data[0].poster_horizontal;
      this.decoration.backgroundImage = response.data[0].poster_horizontal === '' ? 'https://storage.googleapis.com/balde-1/various/placeholders/noimg_x.png' : response.data[0].poster_horizontal;
      console.log(response.data[0].images);

      this.status = getTVStatus(response.data[0].status);
      this.poster = getImageSource(response.data[0].images, "poster_vertical", "lg", response.data[0].poster_vertical)
      this.bgimg = getImageSource(response.data[0].images, "poster_horizontal", "lg", response.data[0].poster_horizontal)
      this.decoration.backgroundImage = getImageSource(response.data[0].images, "poster_horizontal", "lg", response.data[0].poster_horizontal)

      this.idSerie = response.data[0].idSerie;
      this.typeSerie = response.data[0].tipo;
      this.atribucion = response.data[0].atribucion;
      this.mini.recommended = response.data[0].favorite ? !!response.data[0].favorite : false;
      this.mini.bookmark = response.data[0].bookmark ? !!response.data[0].bookmark : false;
      this.year = response.data[0].year;
    });

    // Request seasons and episodes of this show
    await axios(
        `https://api.videnti.co/tv/getSeasonsAndEpisodes/${this.$route.params.name}`,
        {
          method: (this.isLoggedIn ? "post" : "get"),
          headers: this.isLoggedIn ? { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': `Bearer ${this.$store.state.auth.token}` } : {},
          data: new URLSearchParams()
        }
    ).then(res => {
      if (res.data.error) { this.checkIfJWTExpired(res.data.message); }

      this.temporadas = res.data;
      console.log(res.data);
    })

    // Request publishers
    // TODO Remove request when /getInfo start showing publishers
    await axios
        .get('https://api.videnti.co/publishersBySeriesUrl/' + this.$route.params.name)
        .then(resPublishers => {
          this.publishers = resPublishers.data;
        })

    // Request categories
    // TODO Remove request when /getInfo start showing categories
    await axios
        .get('https://api.videnti.co/categoriasBySerieId/' + this.idSerie)
        .then(resCatgs => {
          this.categorias = resCatgs.data;
          this.isFetching = false;
        });

    this.setCorrectlyFondo();
    window.addEventListener("resize", this.setCorrectlyFondo);
    loading.close();
  },
  methods: {
    showFondo() {
      const bg = document.getElementsByClassName("bgimg")[0];
      bg.animate({ opacity: 0 }, { duration: 1000, easing: "linear", iterations: 1, fill: "both" });

      const bgh = document.getElementsByClassName("bgimg-hidden")[0];
      bgh.animate({ opacity: 1 }, { duration: 1000, easing: "linear", iterations: 1, fill: "both" });

      const content = document.getElementsByClassName("top")[0];
      content.animate({ opacity: 0 }, { duration: 1000, easing: "linear", iterations: 1, fill: "both" });
    },
    unshowFondo() {
      const bg = document.getElementsByClassName("bgimg")[0];
      bg.animate({ opacity: 1 }, { duration: 1000, easing: "linear", iterations: 1, fill: "both" });

      const bgh = document.getElementsByClassName("bgimg-hidden")[0];
      bgh.animate({ opacity: 0 }, { duration: 1000, easing: "linear", iterations: 1, fill: "both" });

      const content = document.getElementsByClassName("top")[0];
      content.animate({ opacity: 1 }, { duration: 1000, easing: "linear", iterations: 1, fill: "both" })
    },
    imageUrlAlt(event, tall) {
      if (tall) {
        event.target.src = "https://storage.googleapis.com/balde-1/various/placeholders/noimg_y.png"
      } else {
        event.target.src = "https://storage.googleapis.com/balde-1/various/placeholders/noimg_x.png"
      }
      // event.target.src = "https://i.imgur.com/Zx6wTMp.png"
    },
    goToEpisode(temporada, episodio) {
      if (window.location.pathname.endsWith("/")) {
        window.location = window.location.origin + window.location.pathname + temporada + "/" + episodio;
      } else {
        window.location = window.location.origin + window.location.pathname + "/" + temporada + "/" + episodio;
      }
    },
    reversee(temporada) {
      this.temporadas[temporada].episodes.reverse();
      if (typeof this.temporadas[temporada].isReversed !== "boolean") {
        this.temporadas[temporada].isReversed = true
      } else {
        this.temporadas[temporada].isReversed = !this.temporadas[temporada].isReversed;
      }
      /* this.reRenderEpisodeList[temporada] += 1; */
      // Remove my-component from the DOM
      this.isFetching = true;

      this.$nextTick(() => {
        // Add the component back in
        this.isFetching = false;
      });
    },
    async markRecommended() {
      if (this.isLoggedIn) {
        await axios
            .post(`https://api.videnti.co/user_markSerieAsRecommended?serie=${this.idSerie}`, new URLSearchParams(), { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } })
            .then(responseRC => {
              if (responseRC.data.error === true) {
                this.$vs.notification({
                  progress: 'auto',
                  color: "danger",
                  duration: "10000",
                  title: (responseRC.data.title ? responseRC.data.title : 'Ocurrió un error'),
                  text: `${responseRC.data.message}`
                })
              } else if (responseRC.data.recommended !== null) {
                console.log(responseRC.data.recommended);
                this.mini.recommended = responseRC.data.recommended;
                this.mini.recommendedTimestamp = responseRC.data.timestamp ? responseRC.data.timestamp : null;

                this.$vs.notification({
                  progress: 'auto',
                  color: (responseRC.data.color ? responseRC.data.color : "success"),
                  duration: "10000",
                  title: (responseRC.data.title ? responseRC.data.title : 'Información'),
                  text: `${responseRC.data.message}`
                })
              }
            });
      }
    },
    async bookmark() {
      if (!this.isLoggedIn) {
        this.$vs.notification({ progress: 'auto', color: "danger", duration: "10000", title: "Error", text: `Necesitar estar autenticado para hacer esto. Inicia sesión primero.` });
        return;
      }
      await axios
          .post(`https://api.videnti.co/user/watchlist/switch?id=${this.idSerie}&type=watch`, new URLSearchParams(), { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } })
          .then(res => {
            if (res.data.error === true) {
              this.$vs.notification({ progress: 'auto', color: "danger", duration: "10000", title: (res.data.title ? res.data.title : 'Ocurrió un error'), text: `${res.data.message}` })
            } else if (res.data.bookmark !== null) {
              this.mini.bookmark = res.data.bookmark;
              this.$vs.notification({ progress: 'auto', color: (res.data.color ? res.data.color : "success"), duration: "10000", title: (res.data.title ? res.data.title : 'Información'), text: `${res.data.message}` });
            }
          });
    },
    unfocus() {
      // blurAll
      let tmp = document.createElement("input");
      tmp.style.position = "fixed";
      document.body.appendChild(tmp);
      tmp.focus();
      document.body.removeChild(tmp);
    },
    setCorrectlyFondo() {
      if (window.innerWidth <= 600) {
        this.decoration.backgroundImage = this.poster;
        this.decoration.directionGradient = "to bottom";
      } else {
        this.decoration.backgroundImage = this.bgimg;
        this.decoration.directionGradient = "to right";
      }
      let height = document.getElementsByClassName("bgimg")[0].clientHeight;
      const hiddenBg = document.getElementsByClassName("bgimg-hidden")[0];
      hiddenBg.style.minHeight = height + "px";

      let poster_height = document.getElementsByClassName("detail-poster")[0].clientHeight;
      let top_height = document.getElementsByClassName("top")[0].clientHeight - (6 * parseFloat(getComputedStyle(document.documentElement).fontSize)); // top - 6rem (padding top)
      let container = document.getElementsByClassName("left-bottom-container")[0];
      container.style.marginTop = Math.max((poster_height - top_height), 0) + "px";
    },
    changeEpisodeViewType(newView, season) {
      this.settings.episodesViewType = newView;
      this.settings.currentSeason = season;
      this.isFetching = true;
      this.$nextTick(() => {
        this.isFetching = false;
      })
    },
    getShowQty() {
      if (this.temporadas.length > 1) {
        return this.temporadas.length + " temporadas"
      } else return (this.temporadas.length === 1) ? this.temporadas[0].count_episodes + " episodios" : "0 videos";
    }
  },
  mounted() {
    if (this.$route.query.error) {
      switch (this.$route.query.error) {
        case "NO_AVAILABLE_LINKS":
          this.$vs.notification({
            progress: 'auto',
            color: "danger",
            duration: "10000",
            title: 'No hay servidores',
            text: `Has accedido a un episodio que no tiene servidores disponibles para que puedas ver el contenido. Reporta esto si el problema persiste por más de 48 horas.`
          })
          break;
        case "EPISODIO_NO_EXISTE":
          this.$vs.notification({
            progress: 'auto',
            color: "danger",
            duration: "10000",
            title: 'Episodio inexistente',
            text: `Has accedido a un episodio de esta serie que no existe. Has sido redirigido a esta página para que puedas mirar los episodios disponibles.`
          })
          break;
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.setCorrectlyFondo);
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: '%s - Ver en Videnti',
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: this.description }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@elbuenanvita/vuesax/src/styles/mixins";

/* New style for large screens. */
@include media-breakpoint-up("md") {
  .poster-side {
    img.detail-poster {
      position: absolute;
    }
  }
}

.info-block {
  margin: .75rem 0;
  &:first-child { margin-top: 0; }
  &:last-child { margin-bottom: 0; }
}

h3.overview-title {
  margin: 0 0 .5rem 0;
  border-bottom: 1px solid #3e3e3e;
  border-radius: 1px;
}

.tab {
  &.tab-episodes {
    justify-content: center;
    @include media-breakpoint-up("md") {
      justify-content: flex-start;
    }
  }
}

.hero-header {
  .show-title {
    @include media-breakpoint-down("sm") {
      text-align: center;
      margin: { top: 1rem; bottom: .5rem; }
      line-height: 1;
    }
  }

  .show-info {
    display: block;
    margin: {
      top: -5px;
      bottom: 0;
    }
    padding: 0;
    line-height: 1em;

    @include media-breakpoint-down("sm") {
      margin: 0;
      text-align: center;
    }
  }

  .show-action-buttons {
    display: flex !important;
    justify-content: end !important;

    @include media-breakpoint-down("sm") {
      margin: 1rem 0;
      order: 1 !important;
      justify-content: center !important;
    }
  }
}

.vs-select-content {
  width: 15rem;
}

.poster-side {
  img.detail-poster {
    object-fit: contain;
    object-position: bottom;

    @media (max-width: 600px) {
      width: 50%;
    }
    width: 85%;
  }
}

.top {
  padding: {
    /* left: 6rem; */
    top: 6rem;
    bottom: 1rem;
    /* bottom: 5%; */
  }
}
</style>

<style scoped>

.episodes-qty {
  font-size: 0.75rem;
  margin-left: 1rem;
  align-self: center;
}

.show-description {
  display: -webkit-box;
  max-width: 1000px;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: .9rem;
  line-height: 1.25rem;
}

.bgimg {
  background-position: center; background-size: cover;
  min-height: 75%;
  top: 0; left: 0; right: 0;
  height: 100%; width: 100%;
  box-sizing: border-box;
  /* box-shadow: inset -800px 0 100px 40px #000; */
  color: #FFF;
  /* float: left;  */
}

.bgimg-hidden {
  background-position: center;
  background-size: cover;
  /* min-height: 75%; */
  /* top: 60px; */
  left: 0;
  right: 0;
  /* height: 100%; */
  width: 100%;
  box-sizing: border-box;
  color: #FFF;
  float: left;
  position: absolute !important;
  z-index: -10;
  opacity: 0;
}

.h1 {
  text-decoration: none;
  /* font-size: 25pt; */
  font-size: 2.5rem;
  font-weight: bold;
}
/* .episodes {
  margin-top: -100px;
} */
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.vs-alert {
  margin-bottom: 10px;
}

.vs-card__img {
  display: block;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
}

.thumbNail:after {
  content: "";
  display: block;
  padding-top: 56.25%;
}

@media only screen and (max-width: 600px) {
  img.detail-poster {
    width: 50%;
  }
  .top {
    padding-left: 0;
    padding-bottom: 2rem;
  }
  .youNeedCoolAir {
    padding: 0 2rem;
  }
}

/* @media only screen and (max-width: 645px) {
  .top { padding-left: 5%; }
  .youNeedCoolAir { padding-left: 5%; }
} */

.badge {
  display: inline-block;
  font-size: .9rem;
  border-radius: 5px;
  padding: 1px 5px;
  color: #fff;
  margin-right: 0;
  background-color: #42b983;
  cursor: default;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.badge.top {
  vertical-align: top;
}

.badge.middle {
  vertical-align: middle;
}

article {
  position: static !important;
}
</style>

<style>
.episode-name-cut-legacy {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
}

/* Tamaño del scroll */
.vs-card__group-cards::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

/* Estilos barra (thumb) de scroll */
.vs-card__group-cards::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.vs-card__group-cards::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}

.vs-card__group-cards::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

/* Estilos track de scroll */
.vs-card__group-cards::-webkit-scrollbar-track {
  /* background: #000; */
  background: rgba(var(--vs-color), 0.1);
  border-radius: 4px;
}

.vs-card__group-cards::-webkit-scrollbar-track:hover,
.vs-card__group-cards::-webkit-scrollbar-track:active {
  background: rgba(var(--vs-color), 0.1);
  /*background: #000;*/
}

.vs-alert {
  height: auto !important;
}
</style>
<style>
button[style*="--vs-color:255,255,255;"].vs-button--active,
button[style*="--vs-color:255,255,255;"].vs-button--border:focus {
  color: black;
}
</style>
